import VideoWizardCustomizeStep, {
  VideoWizardCustomizeStepProps,
} from './VideoWizardCustomizeStep';

export default VideoWizardCustomizeStep;
export { VideoWizardCustomizeStepProps };
